function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export default function Cancel(props) {
  const {
    fillColor,
    style,
    ...restProps
  } = props;
  const newstyle = {
    width: "auto",
    ...style
  };
  const fill = fillColor || "#000";
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, restProps, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
  }));
}